<div class="s09-designer">
  <div class="s09-designer-bar" *ngIf="!hideNameBar" [class.actions-only]="hideNameBar">
    <div class="s09-designer-meta" *ngIf="!hideNameBar">
      <input [ngModel]="wfName" (ngModelChange)="nameChange.emit($event)" placeholder="Workflow name" />
      <span class="s09-chip">v{{ version }}</span>
      <span class="s09-chip" [class.status-draft]="status!=='ACTIVE'" [class.status-active]="status==='ACTIVE'">{{ status }}</span>
    </div>
    <div class="s09-designer-actions">
      <button type="button" class="s09-btn s09-lib-toggle" [class.on]="libOpen" (click)="libOpen ? closeLibrary() : openLibrary()">
        {{ libOpen ? 'Hide steps' : 'Add step' }}
      </button>
      <button type="button" class="s09-btn" (click)="addCanvasAttempt()">Add attempt</button>
      <button type="button" class="s09-btn" (click)="openTrigger()">Trigger</button>
      <button type="button" class="s09-btn" [disabled]="!canUndo" title="Undo (Ctrl+Z)" (click)="undo()">Undo</button>
      <button type="button" class="s09-btn" [disabled]="!canRedo" title="Redo (Ctrl+Y)" (click)="redo()">Redo</button>
      <button type="button" class="s09-btn danger-text s09-btn-delete-bar"
        [disabled]="!canDeleteStep"
        title="Delete selected step (Del)"
        (click)="removeSelected()">Delete</button>
      <button type="button" class="s09-btn s09-val-toggle" [class.on]="valOpen && !hasInspector"
        title="Validation" (click)="toggleValidation()">
        Validation
        <span class="s09-val-dot" [class.ok]="valBadge.ok" [class.bad]="!valBadge.ok"></span>
      </button>
      <button type="button" class="s09-btn" title="Stack nodes vertically" (click)="autoArrange()">Arrange</button>
      <button type="button" class="s09-btn" (click)="back.emit()">Back</button>
      <button type="button" class="s09-btn primary" [disabled]="saving" (click)="save.emit()">
        {{ saving ? 'Saving…' : 'Save' }}
      </button>
      <button *ngIf="status !== 'ACTIVE'" type="button" class="s09-btn active-green" (click)="activate.emit()">Activate</button>
      <button *ngIf="status === 'ACTIVE'" type="button" class="s09-btn" (click)="pause.emit()">Pause</button>
    </div>
  </div>

  <div class="s09-grid" [class.lib-open]="libOpen" [class.rail-open]="rightRailOpen">
    <!-- Step Library drawer -->
    <aside class="s09-panel s09-lib" *ngIf="libOpen" (mousedown)="$event.stopPropagation()">
      <div class="s09-panel-h">
        <div class="s09-lib-title-row">
          <h3>{{ libTitle() }}</h3>
          <button type="button" class="s09-icon-btn" (click)="closeLibrary()" title="Close">×</button>
        </div>
        <div class="s09-search" style="width:100%">
          <input class="s09-lib-search" placeholder="Search steps" [(ngModel)]="libQuery" (ngModelChange)="onLibQuery()" />
        </div>
        <span class="s09-lib-hint" *ngIf="moduleInsertAt == null && !afterInsert && !linkInsert">{{ libraryCount }} steps · click to add · closes when you click away</span>
        <span class="s09-lib-hint" *ngIf="linkInsert">This step is inserted on the selected connection</span>
        <span class="s09-lib-hint" *ngIf="moduleInsertAt != null">Pick a workflow step for this Office Outreach Module</span>
        <span class="s09-lib-hint" *ngIf="afterInsert">Pick a step to run after this attempt</span>
      </div>
      <div class="s09-lib-scroll">
        <div *ngIf="!library.length" class="s09-lib-empty">No step matches that search.</div>
        <div class="s09-lib-group" *ngFor="let grp of library; trackBy: trackGroup">
          <span>{{ grp.group }}</span>
          <div class="s09-lib-item" *ngFor="let it of grp.items; trackBy: trackLibItem"
            [class.future]="it.future" (click)="addStep(it.kind, it.future)">
            <span class="s09-ico" [style.background]="it.colour">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="it.path"></path></svg>
            </span>
            <div style="min-width:0;display:flex;flex-direction:column;gap:1px">
              <div style="display:flex;align-items:center;gap:6px">
                <span class="s09-lib-label">{{ it.label }}</span>
                <span class="s09-roadmap" *ngIf="it.future">ROADMAP</span>
              </div>
              <span class="s09-lib-sub">{{ it.sub }}</span>
            </div>
          </div>
        </div>
      </div>
    </aside>

    <!-- Free-position canvas: drag to move, corner to resize -->
    <div class="s09-canvas" [class.linking]="!!linkGesture">
      <div class="s09-toast" *ngIf="toast">{{ toast }}</div>
      <div class="s09-canvas-hint">Drop a connector on the top, left, or right of a step. Drag the side dot to connect steps in a row.</div>
      <div class="s09-canvas-scroll">
        <div class="s09-canvas-world" [style.width.px]="worldW" [style.height.px]="worldH">
          <svg class="s09-wires" [attr.width]="worldW" [attr.height]="worldH">
            <defs>
              <marker id="s09-arrow" markerWidth="8" markerHeight="8" refX="7" refY="3" orient="auto">
                <path d="M0,0 L7,3 L0,6 Z" fill="context-stroke"></path>
              </marker>
            </defs>
            <g *ngFor="let w of wires(); trackBy: trackWire" class="s09-wire"
              [class.on]="wireHover===w.key || wireSelected===w.key">
              <path class="s09-wire-hit" [attr.d]="w.d"
                (pointerdown)="onWireDown($event, w)"
                (pointerenter)="wireHover=w.key"
                (pointerleave)="wireHover=null" />
              <path class="s09-wire-line" [attr.d]="w.d" marker-end="url(#s09-arrow)" />
            </g>
            <path *ngIf="linkGesture" class="s09-wire-rubber" [attr.d]="rubberPath()" />
          </svg>
          <ng-container *ngFor="let w of wires(); trackBy: trackWire">
            <span class="s09-wire-label" *ngIf="w.branch"
              [class.false]="w.branch==='false'"
              [class.escalate]="w.branch==='escalate'"
              [class.wait]="w.branch==='wait'"
              [style.left.px]="w.hx" [style.top.px]="w.hy - 18">{{ branchLabel(w.branch) }}</span>
            <button type="button" class="s09-wire-grip"
              [class.on]="wireHover===w.key || wireSelected===w.key || bendGesture?.from===w.from && bendGesture?.to===w.to"
              [style.left.px]="w.hx - 6" [style.top.px]="w.hy - 6"
              title="Drag to move this line. Double-click to straighten it."
              (pointerdown)="startBend($event, w)"
              (pointerenter)="wireHover=w.key"
              (pointerleave)="wireHover=null"
              (dblclick)="resetBend(w)"></button>
            <button type="button" class="s09-wire-end"
              [class.on]="wireHover===w.key || wireSelected===w.key || !!linkGesture"
              [style.left.px]="w.ex + w.nx" [style.top.px]="w.ey + w.ny"
              title="Drag onto the top, left, or right of a step, or drop on empty canvas to detach"
              (pointerdown)="startLink($event, w.from, w.to, w.branch)"
              (pointerenter)="wireHover=w.key"></button>
          </ng-container>

          <div class="s09-empty-canvas s09-empty-float" *ngIf="!doc.steps.length"
            [style.left.px]="triggerGeom.x" [style.top.px]="(triggerGeom.y || 40) + 90">
            <strong>No steps yet</strong>
            <span>Add a step, then drag it anywhere on the canvas.</span>
            <div class="s09-empty-actions">
              <button type="button" class="s09-btn s09-lib-toggle primary" (click)="openLibrary()">Add step</button>
            </div>
          </div>

          <!-- Trigger -->
          <div class="s09-trigger-pill s09-canvas-node"
            [class.selected]="inspMode==='trigger'"
            [style.left.px]="triggerGeom.x" [style.top.px]="triggerGeom.y" [style.width.px]="triggerGeom.w"
            (pointerdown)="startDrag($event, 'trigger', null, triggerGeom.x || 0, triggerGeom.y || 0)">
            <span class="s09-drag-grip" title="Drag">⋮⋮</span>
            <span class="s09-ico" [style.background]="triggerAccent" style="width:28px;height:28px">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="triggerPath"></path></svg>
            </span>
            <div style="min-width:0">
              <span class="s09-trigger-pill-lbl">Trigger</span>
              <span class="s09-trigger-pill-val">{{ triggerLabel }}</span>
            </div>
            <span class="s09-trigger-pill-cta">Configure</span>
            <button type="button" class="s09-port out" data-port="trigger-out" title="Drag to connect"
              (pointerdown)="startLink($event, 'trigger', null)"></button>
          </div>

          <!-- Steps -->
          <div class="s09-node s09-canvas-node" *ngFor="let n of doc.steps; trackBy: trackStep"
            [class.selected]="selectedId===n.id"
            [attr.data-step]="n.id"
            [class.link-hot]="linkGesture?.over===n.id"
            [style.left.px]="n.x" [style.top.px]="n.y" [style.width.px]="n.w"
            [style.height.px]="n.h || null"
            [style.border-top-color]="catalog(n.kind)?.colour || '#1360DF'"
            (pointerdown)="startDrag($event, 'step', n.id, n.x || 0, n.y || 0)"
            (click)="onNodeClick(n, $event)">
            <button type="button" class="s09-port in" [class.hot]="linkGesture?.over===n.id && linkGesture?.side==='top'"
              [attr.data-port]="n.id + '-in'" title="Drop a connection on the top"
              (pointerdown)="$event.stopPropagation()"></button>
            <button type="button" class="s09-port in left" [class.hot]="linkGesture?.over===n.id && linkGesture?.side==='left'"
              [attr.data-port]="n.id + '-in-left'" title="Drop a connection on the left side"
              (pointerdown)="$event.stopPropagation()"></button>
            <button type="button" class="s09-port in right" [class.hot]="linkGesture?.over===n.id && linkGesture?.side==='right'"
              [attr.data-port]="n.id + '-in-right'" title="Drop a connection on the right side"
              (pointerdown)="$event.stopPropagation()"></button>
            <div class="s09-node-h">
              <span class="s09-drag-grip" title="Drag">⋮⋮</span>
              <span class="s09-ico" [style.background]="catalog(n.kind)?.colour || '#1360DF'" style="width:32px;height:32px">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="catalog(n.kind)?.path || 'M5 12h14'"></path></svg>
              </span>
              <div class="s09-node-titles">
                <span class="s09-node-group" [style.color]="catalog(n.kind)?.colour">{{ catalog(n.kind)?.group }}</span>
                <span class="s09-node-label">{{ stepTitle(n) }}</span>
              </div>
              <button
                type="button"
                class="s09-node-del"
                title="Delete step"
                (pointerdown)="$event.stopPropagation()"
                (click)="deleteStepFromCanvas(n.id, $event)">×</button>
            </div>

            <div class="s09-node-body">
              <div class="s09-node-rows" *ngIf="nodeRows(n).length">
                <div class="s09-node-row" *ngFor="let rw of nodeRows(n)">
                  <span>{{ rw.label }}</span>
                  <span class="s09-code-chips" *ngIf="rw.chips?.length; else rowText">
                    <span class="s09-code-chip" *ngFor="let c of rw.chips || []">{{ c }}</span>
                  </span>
                  <ng-template #rowText><span>{{ rw.value }}</span></ng-template>
                </div>
              </div>

              <div class="s09-attempts" *ngIf="n.kind==='outreachModule' && n.mod">
                <div class="s09-att-grid" [style.gridTemplateColumns]="attCols(n.mod.attempts.length)">
                  <div class="s09-att" *ngFor="let at of n.mod.attempts; let i = index"
                    [class.selected]="selectedId===n.id && selectedAttempt===i"
                    (pointerdown)="$event.stopPropagation()"
                    (click)="selectAttempt(n.id, i, $event)">
                    <span class="s09-att-day">Attempt {{ i+1 }} · day {{ at.day || '?' }}</span>
                    <span style="font-size:12px;font-weight:600">{{ attemptTitle(at) }}</span>
                    <span style="font-size:11px;color:var(--s09-text-2)">{{ at.channel || 'Channel not set' }}</span>
                    <span class="s09-mod-step-chips" *ngIf="at.after.length">
                      <span class="s09-mod-step-chip" *ngFor="let ms of at.after">{{ catalog(ms.kind)?.label || ms.kind }}</span>
                    </span>
                  </div>
                </div>
                <div class="s09-mod-step-chips" *ngIf="n.mod.steps.length">
                  <button type="button" class="s09-mod-step-chip" *ngFor="let ms of n.mod.steps"
                    (pointerdown)="$event.stopPropagation()"
                    (click)="selectModuleStep(n.id, ms.id, $event)">{{ catalog(ms.kind)?.label || ms.kind }}</button>
                </div>
                <div class="s09-mod-foot">
                  <span class="s09-mod-next">↻ {{ n.mod.optional ? 'Optional for FRM' : 'No milestone → next attempt' }}</span>
                  <span>Wait <b>{{ n.mod.wait }}</b>d · Esc <b>{{ n.mod.escalate ? 'On' : 'Off' }}</b></span>
                </div>
              </div>

              <div class="s09-gate-bar" *ngIf="isGated(n.kind)">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                  stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="10" width="16" height="11" rx="2"></rect><path d="M8 10V7a4 4 0 0 1 8 0v3"></path></svg>
                {{ gateText(n.kind) }}
              </div>
            </div>

            <button type="button" class="s09-port out false" *ngIf="n.kind==='condition'"
              [attr.data-port]="n.id + '-false'" title="Drag the False branch"
              (pointerdown)="startLink($event, n.id, null, 'false')">False</button>
            <button type="button" class="s09-port out true" *ngIf="n.kind==='condition'"
              [attr.data-port]="n.id + '-true'" title="Drag the True branch"
              (pointerdown)="startLink($event, n.id, null, 'true')">True</button>
            <button type="button" class="s09-port out escalate" *ngIf="n.kind==='frmDecision'"
              [attr.data-port]="n.id + '-escalate'" title="Drag where the case goes if the FRM escalates"
              (pointerdown)="startLink($event, n.id, null, 'escalate')">Escalate</button>
            <button type="button" class="s09-port out wait" *ngIf="n.kind==='frmDecision'"
              [attr.data-port]="n.id + '-wait'" title="Drag the Wait branch. The Wait / Delay step on this branch uses the days the FRM enters."
              (pointerdown)="startLink($event, n.id, null, 'wait')">Wait</button>
            <button type="button" class="s09-port out" *ngIf="n.kind!=='condition' && n.kind!=='frmDecision'"
              [attr.data-port]="n.id + '-out'"
              title="Drag onto another step to connect"
              (pointerdown)="startLink($event, n.id, null)"></button>
            <button type="button" class="s09-port out right" *ngIf="n.kind!=='condition' && n.kind!=='frmDecision'"
              [attr.data-port]="n.id + '-out-right'"
              title="Drag sideways into the left or right of another step"
              (pointerdown)="startLink($event, n.id, null, null, 'right')"></button>
            <div class="s09-resize" title="Drag to resize this step"
              (pointerdown)="startResize($event, n)"></div>
          </div>

        </div>
      </div>
    </div>

    <!-- Right rail: inspector OR validation -->
    <aside class="s09-panel s09-insp" *ngIf="hasInspector">
      <div class="s09-insp-h">
        <div style="display:flex;align-items:center;gap:11px;min-width:0">
          <span class="s09-ico" style="width:32px;height:32px"
            [style.background]="inspMode==='trigger' ? triggerAccent : (catalog(selected?.kind||'')?.colour || '#1360DF')">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <path [attr.d]="inspMode==='trigger' ? triggerPath : (catalog(selected?.kind||'')?.path || 'M5 12h14')"></path>
            </svg>
          </span>
          <div style="display:flex;flex-direction:column;gap:1px;min-width:0">
            <span class="s09-insp-eyebrow" *ngIf="inspMode==='trigger'">Trigger</span>
            <span class="s09-insp-eyebrow" *ngIf="inspMode==='step'" [style.color]="catalog(selected?.kind||'')?.colour">
              {{ catalog(selected?.kind||'')?.group }}
            </span>
            <span class="s09-insp-eyebrow" *ngIf="inspMode==='attempt'" style="color:var(--s09-purple)">Office Outreach Module</span>
            <span class="s09-insp-title">
              <ng-container *ngIf="inspMode==='trigger'">Workflow and trigger settings</ng-container>
              <ng-container *ngIf="inspMode==='step'">{{ catalog(selected?.kind||'')?.label }}</ng-container>
              <ng-container *ngIf="inspMode==='attempt'">Attempt {{ (selectedAttempt||0)+1 }}</ng-container>
            </span>
          </div>
        </div>
        <button type="button" class="s09-icon-btn danger" (click)="closeInspector()">×</button>
      </div>

      <!-- Trigger -->
      <div class="s09-insp-body" *ngIf="inspMode==='trigger'">
        <div class="s09-field">
          <label>Code</label>
          <input [ngModel]="doc.meta.code" (ngModelChange)="patchMeta('code', $event)" />
        </div>
        <div class="s09-field">
          <label>Priority</label>
          <div class="s09-chip-row">
            <button type="button" class="s09-choice" *ngFor="let p of ['Low','Medium','High']"
              [class.on]="doc.meta.priority===p" (click)="patchMeta('priority', p)">{{ p }}</button>
          </div>
        </div>
        <div class="s09-field">
          <label>Case type</label>
          <select [ngModel]="doc.meta.caseTypeKey" (ngModelChange)="pickCaseType($event)">
            <option [ngValue]="null">Select a case type…</option>
            <option *ngFor="let t of caseTypes" [ngValue]="t.typeKey">{{ t.name }}</option>
          </select>
          <span class="s09-field-hint">Move to case stage uses the stages from the landing Case Flow tab.</span>
        </div>
        <div class="s09-field">
          <label>Trigger type</label>
          <div class="s09-chip-row">
            <button type="button" class="s09-choice" *ngFor="let t of triggers"
              [class.on]="doc.trigger===t.id" (click)="patchTrigger(t.id)">{{ t.label }}</button>
          </div>
        </div>
        <div class="s09-field">
          <label>Condition / threshold <span class="s09-opt">(optional)</span></label>
          <div *ngIf="conditionsHint" class="s09-field-hint">{{ conditionsHint }}</div>
          <div class="s09-chip-row" *ngIf="conditionsForTrigger.length">
            <button type="button" class="s09-choice" *ngFor="let c of conditionsForTrigger"
              [class.on]="doc.meta.threshold===c.condition_label"
              (click)="pickCondition(c.condition_label)">{{ c.condition_label }}</button>
          </div>
          <input style="margin-top:8px" [ngModel]="doc.meta.threshold"
            (ngModelChange)="patchMeta('threshold', $event)"
            placeholder="Select above or type a custom condition" />
        </div>
        <div class="s09-field">
          <label>Signals</label>
          <div class="s09-code-chips" style="min-height:24px">
            <span *ngFor="let c of doc.meta.codes" class="s09-code-chip on">{{ c }}</span>
            <span *ngIf="!doc.meta.codes.length" class="s09-field-hint">None selected.</span>
          </div>
          <div *ngIf="signalsHint" class="s09-field-hint danger">{{ signalsHint }}</div>
          <div *ngFor="let g of signalGroups" style="margin-top:8px">
            <div class="s09-section-lbl">{{ g.group_label }}</div>
            <div class="s09-code-chips">
              <button type="button" class="s09-code-chip" *ngFor="let s of g.signals"
                [class.on]="hasEntrySignal(s.signal_code)"
                (click)="toggleEntrySignal(s.signal_code)"
                [title]="signalTip(s)"
                [attr.aria-label]="signalTip(s)">{{ s.signal_code }}</button>
            </div>
          </div>
        </div>
        <div class="s09-field">
          <label>Codes (CSV)</label>
          <input class="s09-mono-input" [ngModel]="(doc.meta.codes || []).join(', ')" (ngModelChange)="setCodesCsv($event)" />
        </div>
      </div>

      <!-- Standard step fields -->
      <div class="s09-insp-body" *ngIf="inspMode==='step' && selected && !isOutreachStep">
        <ng-container *ngIf="selected.kind==='attempt'">
          <div class="s09-field">
            <label>Name</label>
            <input [ngModel]="selected.values['name']" (ngModelChange)="patchStepValue('name', $event)" placeholder="Attempt 1" />
            <span class="s09-field-hint">Name it Attempt 1, or Day 1 Attempt.</span>
          </div>
          <div class="s09-field">
            <label>When does this attempt run?</label>
            <div class="s09-chip-row">
              <button type="button" class="s09-choice" *ngFor="let when of attemptWhen()"
                [class.on]="selected.values['runsAfter']===when"
                (click)="patchStepValue('runsAfter', when)">{{ when }}</button>
            </div>
            <span class="s09-field-hint">Business days after the trigger. The name stays Attempt 1 even if it runs after 2 days.</span>
          </div>
          <div class="s09-field">
            <label>Template</label>
            <select [ngModel]="selected.values['template']" (ngModelChange)="patchStepValue('template', $event)">
              <option value="">Choose a template…</option>
              <option *ngFor="let t of templates" [value]="t.id">{{ t.name }}</option>
            </select>
            <div class="s09-tpl-preview" *ngIf="selectedTemplate">
              <span class="s09-section-lbl">Template content</span>
              <div class="s09-tpl-card">
                <span class="s09-tpl-kind">{{ selectedTemplate.kind || 'Template' }}</span>
                <strong>{{ selectedTemplate.subject || selectedTemplate.name }}</strong>
                <span class="s09-tpl-body">{{ selectedTemplate.body || 'This template has no content yet.' }}</span>
              </div>
              <span class="s09-field-hint">Words in [brackets] are filled from the case.</span>
            </div>
          </div>
          <div class="s09-field">
            <label>To</label>
            <div class="s09-chip-row" *ngIf="mailList(selected.values['to']).length">
              <span class="s09-choice on" *ngFor="let item of mailList(selected.values['to'])">
                {{ mailLabel(item) }}
                <button type="button" class="s09-wire-x" title="Remove" (click)="removeAttemptMail('to', item)">×</button>
              </span>
            </div>
            <div class="s09-mail-add">
              <select [(ngModel)]="toPick">
                <option value="">Contact field…</option>
                <option *ngFor="let key of contactChoices('to')" [value]="key">{{ key }}</option>
              </select>
              <button type="button" class="s09-btn" [disabled]="!toPick" (click)="addAttemptMailField('to')">Add</button>
            </div>
            <div class="s09-mail-add">
              <input [(ngModel)]="toEmail" placeholder="name@company.com" (keydown.enter)="$event.preventDefault(); addAttemptMailText('to')" />
              <button type="button" class="s09-btn" [disabled]="!toEmail.trim()" (click)="addAttemptMailText('to')">Add email</button>
            </div>
            <span class="s09-field-hint">HCP / Office contact → boopathi.a@dataunveil.com · FRM → gabby.mullin@dataunveil.com · SP contact → subash.p@dataunveil.com. Use Office contact on To for practice emails; put FRM on Cc when needed. Type an email here to override.</span>
          </div>
          <div class="s09-field">
            <label>Cc</label>
            <div class="s09-chip-row" *ngIf="mailList(selected.values['cc']).length">
              <span class="s09-choice on" *ngFor="let item of mailList(selected.values['cc'])">
                {{ mailLabel(item) }}
                <button type="button" class="s09-wire-x" title="Remove" (click)="removeAttemptMail('cc', item)">×</button>
              </span>
            </div>
            <div class="s09-mail-add">
              <select [(ngModel)]="ccPick">
                <option value="">Contact field…</option>
                <option *ngFor="let key of contactChoices('cc')" [value]="key">{{ key }}</option>
              </select>
              <button type="button" class="s09-btn" [disabled]="!ccPick" (click)="addAttemptMailField('cc')">Add</button>
            </div>
            <div class="s09-mail-add">
              <input [(ngModel)]="ccEmail" placeholder="name@company.com" (keydown.enter)="$event.preventDefault(); addAttemptMailText('cc')" />
              <button type="button" class="s09-btn" [disabled]="!ccEmail.trim()" (click)="addAttemptMailText('cc')">Add email</button>
            </div>
            <span class="s09-field-hint" *ngIf="mailHint">{{ mailHint }}</span>
          </div>
          <div class="s09-field">
            <label>After this attempt</label>
            <select [ngModel]="selected.values['onOutcome']" (ngModelChange)="patchStepValue('onOutcome', $event)">
              <option *ngFor="let o of attemptGoOptions(selected, true)" [value]="o.id">{{ o.label }}</option>
            </select>
            <span class="s09-field-hint">Where to go once this attempt has an outcome.</span>
          </div>
        </ng-container>
        <ng-container *ngIf="selected.kind==='condition'">
          <div class="s09-field">
            <label>Check</label>
            <select [ngModel]="selected.values['left']" (ngModelChange)="setConditionAttr($event)">
              <option value="">Attribute…</option>
              <option *ngFor="let a of conditionAttrs()" [value]="a">{{ a }}</option>
            </select>
            <div class="s09-chip-row">
              <button type="button" class="s09-choice" *ngFor="let o of conditionOps"
                [class.on]="selected.values['op']===o"
                (click)="setConditionOp(o)">{{ o }}</button>
            </div>
            <ng-container *ngIf="selected.values['left']==='Latest status code'; else conditionValue">
              <input type="search" [ngModel]="statusCodeFilter" (ngModelChange)="statusCodeFilter=$event"
                placeholder="Filter status codes" />
              <div class="s09-code-chips" *ngIf="conditionCodesSelected().length">
                <span class="s09-code-chip on" *ngFor="let c of conditionCodesSelected()">{{ c }}</span>
              </div>
              <div class="s09-code-chips s09-code-pick">
                <button type="button" class="s09-code-chip" *ngFor="let r of conditionCodeChoices()"
                  [class.on]="isConditionCodeOn(r.reason_code)"
                  [title]="r.reason_desc || r.reason_code"
                  (click)="toggleConditionCode(r.reason_code)">{{ r.reason_code }}</button>
              </div>
              <span class="s09-field-hint">In and Not In can take more than one code. Equal and Not equal keep one.</span>
            </ng-container>
            <ng-template #conditionValue>
              <input [ngModel]="selected.values['right']" (ngModelChange)="patchStepValue('right', $event)" placeholder="Value" />
            </ng-template>
          </div>
          <div class="s09-field">
            <label>When false, go to</label>
            <select [ngModel]="branchTarget(selected.id, 'false')" (ngModelChange)="setBranch(selected.id, 'false', $event)">
              <option value="">Choose a step…</option>
              <option *ngFor="let s of linkTargets(selected.id)" [value]="s.id">{{ stepTitle(s) }}</option>
              <option *ngIf="branchTarget(selected.id, 'false')" [value]="branchTarget(selected.id, 'false')">{{ linkLabel(branchTarget(selected.id, 'false')) }}</option>
            </select>
          </div>
          <div class="s09-field">
            <label>When true, go to</label>
            <select [ngModel]="branchTarget(selected.id, 'true')" (ngModelChange)="setBranch(selected.id, 'true', $event)">
              <option value="">Choose a step…</option>
              <option *ngFor="let s of linkTargets(selected.id)" [value]="s.id">{{ stepTitle(s) }}</option>
              <option *ngIf="branchTarget(selected.id, 'true')" [value]="branchTarget(selected.id, 'true')">{{ linkLabel(branchTarget(selected.id, 'true')) }}</option>
            </select>
            <span class="s09-field-hint">False leaves from the left. True leaves from the right. You can also drag those ports on the step.</span>
          </div>
        </ng-container>
        <ng-container *ngIf="selected.kind==='frmDecision'">
          <div class="s09-field">
            <label>Ask the FRM</label>
            <input [ngModel]="selected.values['ask']" (ngModelChange)="patchStepValue('ask', $event)" />
            <span class="s09-field-hint">The FRM answers this on the case: escalate, or wait.</span>
          </div>
          <div class="s09-field">
            <label>Wait is counted in</label>
            <div class="s09-chip-row">
              <button type="button" class="s09-choice" *ngFor="let u of frmWaitUnits"
                [class.on]="selected.values['unit']===u"
                (click)="patchStepValue('unit', u)">{{ u }}</button>
            </div>
          </div>
          <div class="s09-field">
            <label>Longest wait the FRM can enter</label>
            <input type="number" min="1" [ngModel]="selected.values['maxDays']" (ngModelChange)="setFrmMaxDays($event)" placeholder="No limit" />
            <span class="s09-field-hint">Leave this blank when any number of days is allowed.</span>
          </div>
          <div class="s09-field">
            <label>If the FRM escalates, go to</label>
            <select [ngModel]="branchTarget(selected.id, 'escalate')" (ngModelChange)="setBranch(selected.id, 'escalate', $event)">
              <option value="">Choose a step…</option>
              <option *ngFor="let s of linkTargets(selected.id)" [value]="s.id">{{ stepTitle(s) }}</option>
              <option *ngIf="branchTarget(selected.id, 'escalate')" [value]="branchTarget(selected.id, 'escalate')">{{ linkLabel(branchTarget(selected.id, 'escalate')) }}</option>
            </select>
          </div>
          <div class="s09-field">
            <label>After the wait, go to</label>
            <select [ngModel]="branchTarget(selected.id, 'wait')" (ngModelChange)="setBranch(selected.id, 'wait', $event)">
              <option value="">Choose a step…</option>
              <option *ngFor="let s of linkTargets(selected.id)" [value]="s.id">{{ stepTitle(s) }}</option>
              <option *ngIf="branchTarget(selected.id, 'wait')" [value]="branchTarget(selected.id, 'wait')">{{ linkLabel(branchTarget(selected.id, 'wait')) }}</option>
            </select>
            <span class="s09-field-hint">Add a Wait / Delay step here. Set its delay to Days from the previous step so it uses the days the FRM enters.</span>
          </div>
        </ng-container>
        <ng-container *ngIf="selected.kind==='assignCase'">
          <div class="s09-field">
            <label>Assign the case to</label>
            <select [ngModel]="selected.values['team']" (ngModelChange)="setAssignTeam($event)">
              <option *ngFor="let team of leadershipTeams" [value]="team">{{ team }}</option>
            </select>
            <span class="s09-field-hint">The workflow assigns the case to this leadership team, then continues to the next step.</span>
          </div>
          <div class="s09-field" *ngIf="selected.values['team']==='Another leadership team'">
            <label>Leadership team</label>
            <input [ngModel]="selected.values['teamName']" (ngModelChange)="patchStepValue('teamName', $event)" placeholder="Team name" />
          </div>
          <div class="s09-field">
            <label>Note on the case</label>
            <input [ngModel]="selected.values['note']" (ngModelChange)="patchStepValue('note', $event)" placeholder="Optional" />
          </div>
        </ng-container>
        <ng-container *ngIf="selected.kind!=='attempt' && selected.kind!=='condition' && selected.kind!=='frmDecision' && selected.kind!=='assignCase'">
        <ng-container *ngIf="selected.kind==='createCase'">
          <div class="s09-field">
            <label>Case type</label>
            <input [value]="doc.meta.caseType || 'Not set'" disabled />
            <span class="s09-field-hint">The case is created as the type attached on the trigger. It does not use a different type from this step.</span>
          </div>
        </ng-container>
        <ng-container *ngFor="let f of inspectorFields(selected.kind)">
          <div class="s09-field" *ngIf="f.briefTpl">
            <label>Send to</label>
            <div class="s09-chip-row">
              <button type="button" class="s09-choice" *ngFor="let a of emailAudiences"
                [class.on]="tplOn(selected.values, a)"
                (click)="patchStepValue('tpl', toggleTplAudience(tplMap(selected.values), a))">{{ a }}</button>
            </div>
            <ng-container *ngFor="let a of tplAudiencesOn(selected.values)">
              <label>Email template · {{ a }}</label>
              <select [ngModel]="tplId(selected.values, a)" (ngModelChange)="patchStepValue('tpl', setTplId(tplMap(selected.values), a, $event))">
                <option value="">Choose a template…</option>
                <option *ngFor="let t of templatesFor(a)" [value]="t.id">{{ t.name }}</option>
              </select>
              <div class="s09-tpl-preview" *ngIf="templateById(tplId(selected.values, a)) as tpl">
                <span class="s09-section-lbl">Template content</span>
                <div class="s09-tpl-card">
                  <span class="s09-tpl-kind">{{ tpl.status || tpl.kind || 'Template' }}</span>
                  <strong>{{ tpl.subject || tpl.name }}</strong>
                  <span class="s09-tpl-body">{{ tpl.body || 'This template has no content yet.' }}</span>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="s09-field" *ngIf="!f.briefTpl && f.multi">
            <label>{{ f.label }}</label>
            <div class="s09-chip-row">
              <button type="button" class="s09-choice" *ngFor="let o of dayOptions(null, f, selected.values)"
                [class.on]="hasMulti(selected.values, f.key, o)"
                (click)="toggleStepMulti(f.key, o)">{{ o }}</button>
            </div>
          </div>
          <div class="s09-field" *ngIf="f.allowCustom">
            <label>{{ f.label }}</label>
            <div class="s09-chip-row">
              <button type="button" class="s09-choice" *ngFor="let o of choiceOptions(f)"
                [class.on]="selected.values[f.key]===o"
                (click)="patchStepValue(f.key, o)">{{ o }}</button>
            </div>
            <div class="s09-day-custom" *ngIf="!isPreviousDayDelay(selected.values[f.key])">
              <input type="number" min="1" step="1" placeholder="Amount"
                [ngModel]="customDayCount(selected.values[f.key])"
                (ngModelChange)="patchStepValue(f.key, formatCustomDays($event, customDayUnit(selected.values[f.key])))" />
              <select [ngModel]="customDayUnit(selected.values[f.key])"
                (ngModelChange)="patchStepValue(f.key, formatCustomDays(customDayCount(selected.values[f.key]) || 1, $event))">
                <option value="minutes">Minutes</option>
                <option value="business days">Business days</option>
                <option value="days">Days</option>
              </select>
            </div>
            <span class="s09-field-hint" *ngIf="f.key==='delay' && isPreviousDayDelay(selected.values[f.key])">{{ previousDelayHint(selected.id) }}</span>
            <span class="s09-field-hint" *ngIf="!(f.key==='delay' && isPreviousDayDelay(selected.values[f.key]))">Pick 5 or 10 minutes, a number of days, or the days from the previous step.</span>
          </div>
          <div class="s09-field" *ngIf="!f.briefTpl && !f.multi && isChoiceField(f) && !f.allowCustom">
            <label>{{ f.label }}</label>
            <span class="s09-field-hint" *ngIf="f.key==='stage' && stageHint">{{ stageHint }}</span>
            <select [ngModel]="f.key==='from' ? waitFrom(selected.values) : selected.values[f.key]" (ngModelChange)="patchStepValue(f.key, $event)">
              <option value="" disabled>Select…</option>
              <option *ngFor="let o of choiceOptions(f)" [value]="o">{{ o }}</option>
            </select>
            <span class="s09-field-hint" *ngIf="f.key==='from'">Since the last step starts when the previous step finishes. From the start of the workflow counts from the day this workflow began.</span>
          </div>
          <div class="s09-field" *ngIf="!f.briefTpl && !f.multi && !isChoiceField(f)">
            <label>{{ f.label }}</label>
            <input [ngModel]="selected.values[f.key]" (ngModelChange)="patchStepValue(f.key, $event)" />
          </div>
        </ng-container>
        </ng-container>

        <div class="s09-field" *ngIf="isGatedStep">
          <div class="s09-gate-head">
            <label>{{ hasCatalogGates(selected.kind) ? 'Check' : 'Gate chain' }}</label>
            <button type="button" class="s09-link-muted" *ngIf="!hasCatalogGates(selected.kind)" (click)="tryRemoveGate()">Remove gate</button>
          </div>
          <div class="s09-chip-row">
            <span class="s09-gate-chip" *ngFor="let g of gateList(selected.kind)">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="10" width="16" height="11" rx="2"></rect><path d="M8 10V7a4 4 0 0 1 8 0v3"></path></svg>
              {{ g }}
            </span>
          </div>
          <div class="s09-gate-refuse" *ngIf="gateRefused">
            <strong>The gate chain is structural</strong>
            <span>It belongs to the step type, not to this step. There is no send step that skips consent, frequency, or content approval.</span>
          </div>
        </div>

        <button type="button" class="s09-btn danger-text" (click)="removeSelected()">Remove step</button>
      </div>

      <!-- Office Outreach Module -->
      <div class="s09-insp-body" *ngIf="isOutreachStep && selectedMod">
        <div class="s09-field-grid">
          <div class="s09-field">
            <label>Wait after last attempt (days)</label>
            <input type="number" min="0" [ngModel]="selectedMod.wait" (ngModelChange)="patchMod('wait', +$event || 0)" />
          </div>
          <div class="s09-field">
            <label>Repeat every (days)</label>
            <input type="number" min="0" [ngModel]="selectedMod.every" (ngModelChange)="patchMod('every', +$event || 0)" />
            <span class="s09-field-hint">0 = no repeat</span>
          </div>
        </div>
        <div class="s09-field">
          <label>When attempts run out</label>
          <div class="s09-chip-row">
            <button type="button" class="s09-choice" [class.on]="selectedMod.escalate" (click)="patchMod('escalate', true)">Escalate to FRM leadership</button>
            <button type="button" class="s09-choice" [class.on]="!selectedMod.escalate" (click)="patchMod('escalate', false)">No escalation</button>
          </div>
        </div>
        <div class="s09-field">
          <label>FRM outreach</label>
          <div class="s09-chip-row">
            <button type="button" class="s09-choice" [class.on]="!selectedMod.optional" (click)="patchMod('optional', false)">Required</button>
            <button type="button" class="s09-choice" [class.on]="selectedMod.optional" (click)="patchMod('optional', true)">Optional for FRM</button>
          </div>
        </div>
        <div class="s09-field">
          <label>Attempts</label>
          <span class="s09-field-hint">Day and script for each attempt. Click a number or a canvas card to set channel, office ask, and hub codes.</span>
          <ng-container *ngFor="let at of selectedMod.attempts; let i = index">
            <div class="s09-att-row">
              <button type="button" class="s09-att-num" (click)="selectAttempt(selected!.id, i, $event)">{{ i+1 }}</button>
              <input [ngModel]="at.day" (ngModelChange)="patchAttemptRow(i, 'day', $event)" placeholder="Day" />
              <select [ngModel]="at.tpl" (ngModelChange)="patchAttemptRow(i, 'tpl', $event)">
                <option value="">Pick a script…</option>
                <option *ngFor="let t of templates" [value]="t.id">{{ t.name }}</option>
              </select>
              <button type="button" class="s09-icon-btn danger" [disabled]="selectedMod.attempts.length<=1"
                (click)="removeAttemptAt(i)" title="Remove">×</button>
            </div>
            <div class="s09-attempt-gap">
              <ng-container *ngFor="let ms of at.after; let j = index">
                <div class="s09-mod-step" [class.on]="selectedModStepId===ms.id">
                  <button type="button" class="s09-mod-step-main" (click)="toggleModuleStep(ms.id)">
                    <span class="s09-shared-n">{{ j + 1 }}</span>
                    <span>
                      <span class="s09-shared-txt">{{ catalog(ms.kind)?.label || ms.kind }}</span>
                      <span class="s09-field-hint">{{ modStepSummary(ms) }}</span>
                    </span>
                  </button>
                  <button type="button" class="s09-icon-btn danger" title="Remove"
                    (click)="removeAfterStep(i, j, $event)">×</button>
                </div>
                <div class="s09-mod-step-edit" *ngIf="selectedModStepId===ms.id">
                  <ng-container *ngFor="let f of catalog(ms.kind)?.fields || []">
                    <div class="s09-field" *ngIf="f.briefTpl">
                      <label>Send to</label>
                      <div class="s09-chip-row">
                        <button type="button" class="s09-choice" *ngFor="let a of emailAudiences"
                          [class.on]="tplOn(ms.values, a)"
                          (click)="patchAfterValue(i, ms.id, 'tpl', toggleTplAudience(tplMap(ms.values), a))">{{ a }}</button>
                      </div>
                      <ng-container *ngFor="let a of tplAudiencesOn(ms.values)">
                        <label>Email template · {{ a }}</label>
                        <select [ngModel]="tplId(ms.values, a)" (ngModelChange)="patchAfterValue(i, ms.id, 'tpl', setTplId(tplMap(ms.values), a, $event))">
                          <option value="">Choose a template…</option>
                          <option *ngFor="let t of templatesFor(a)" [value]="t.id">{{ t.name }}</option>
                        </select>
                      </ng-container>
                    </div>
                    <div class="s09-field" *ngIf="!f.briefTpl && f.multi">
                      <label>{{ f.label }}</label>
                      <div class="s09-chip-row">
                        <button type="button" class="s09-choice" *ngFor="let o of dayOptions(selectedMod, f, ms.values)"
                          [class.on]="hasMulti(ms.values, f.key, o)"
                          (click)="toggleAfterMulti(i, ms.id, f.key, o)">{{ o }}</button>
                      </div>
                    </div>
                    <div class="s09-field" *ngIf="f.allowCustom">
                      <label>{{ f.label }}</label>
                      <div class="s09-chip-row">
                        <button type="button" class="s09-choice" *ngFor="let o of choiceOptions(f)"
                          [class.on]="ms.values[f.key]===o"
                          (click)="patchAfterValue(i, ms.id, f.key, o)">{{ o }}</button>
                      </div>
                      <div class="s09-day-custom" *ngIf="!isPreviousDayDelay(ms.values[f.key])">
                        <input type="number" min="1" step="1" placeholder="Your own days"
                          [ngModel]="customDayCount(ms.values[f.key])"
                          (ngModelChange)="patchAfterValue(i, ms.id, f.key, formatCustomDays($event, customDayUnit(ms.values[f.key])))" />
                        <select [ngModel]="customDayUnit(ms.values[f.key])"
                          (ngModelChange)="patchAfterValue(i, ms.id, f.key, formatCustomDays(customDayCount(ms.values[f.key]) || 1, $event))">
                          <option value="business days">Business days</option>
                          <option value="days">Days</option>
                        </select>
                      </div>
                      <span class="s09-field-hint" *ngIf="f.key==='delay' && isPreviousDayDelay(ms.values[f.key])">This step waits the number of days the previous step recorded.</span>
                    </div>
                    <div class="s09-field" *ngIf="!f.briefTpl && !f.multi && isChoiceField(f) && !f.allowCustom">
                      <label>{{ f.label }}</label>
                      <span class="s09-field-hint" *ngIf="f.key==='stage' && stageHint">{{ stageHint }}</span>
                      <select [ngModel]="f.key==='from' ? waitFrom(ms.values) : ms.values[f.key]" (ngModelChange)="patchAfterValue(i, ms.id, f.key, $event)">
                        <option value="" disabled>Select…</option>
                        <option *ngFor="let o of choiceOptions(f)" [value]="o">{{ o }}</option>
                      </select>
                      <span class="s09-field-hint" *ngIf="f.key==='from'">Since the last step starts when the previous step finishes. From the start of the workflow counts from the day this workflow began.</span>
                    </div>
                    <div class="s09-field" *ngIf="!f.briefTpl && !f.multi && !isChoiceField(f) && fieldVisible(ms.kind, ms.values, f)">
                      <label>{{ f.label }}</label>
                      <input [ngModel]="ms.values[f.key]" (ngModelChange)="patchAfterValue(i, ms.id, f.key, $event)" />
                    </div>
                  </ng-container>
                  <div class="s09-chip-row" *ngIf="isGated(ms.kind)">
                    <span class="s09-gate-chip" *ngFor="let g of gateList(ms.kind)">{{ g }}</span>
                  </div>
                </div>
                <button type="button" class="s09-btn-dashed" (click)="openAfterPicker(i, j + 1)">+ Add step</button>
              </ng-container>
              <button type="button" class="s09-btn-dashed" *ngIf="!at.after.length"
                (click)="openAfterPicker(i, 0)">+ Add step</button>
            </div>
          </ng-container>
          <button type="button" class="s09-btn-dashed" (click)="addAttempt()">+ Add attempt</button>
        </div>
        <div class="s09-field">
          <label>Workflow steps</label>
          <span class="s09-field-hint">Add any library step. FRM Action can be assigned to attempt days.</span>
          <ng-container *ngFor="let ms of selectedMod.steps || []; let i = index">
            <div class="s09-mod-step" [class.on]="selectedModStepId===ms.id">
              <button type="button" class="s09-mod-step-main" (click)="toggleModuleStep(ms.id)">
                <span class="s09-shared-n">{{ i + 1 }}</span>
                <span>
                  <span class="s09-shared-txt">{{ catalog(ms.kind)?.label || ms.kind }}</span>
                  <span class="s09-field-hint">{{ modStepSummary(ms) }}</span>
                </span>
              </button>
              <button type="button" class="s09-icon-btn danger" title="Remove step"
                (click)="removeModuleStep(i, $event)">×</button>
            </div>
            <div class="s09-mod-step-edit" *ngIf="selectedModStepId===ms.id">
              <ng-container *ngFor="let f of catalog(ms.kind)?.fields || []">
                <div class="s09-field" *ngIf="f.briefTpl">
                  <label>Send to</label>
                  <div class="s09-chip-row">
                    <button type="button" class="s09-choice" *ngFor="let a of emailAudiences"
                      [class.on]="tplOn(ms.values, a)"
                      (click)="patchModuleStepValue(ms.id, 'tpl', toggleTplAudience(tplMap(ms.values), a))">{{ a }}</button>
                  </div>
                  <ng-container *ngFor="let a of tplAudiencesOn(ms.values)">
                    <label>Email template · {{ a }}</label>
                    <select [ngModel]="tplId(ms.values, a)" (ngModelChange)="patchModuleStepValue(ms.id, 'tpl', setTplId(tplMap(ms.values), a, $event))">
                      <option value="">Choose a template…</option>
                      <option *ngFor="let t of templatesFor(a)" [value]="t.id">{{ t.name }}</option>
                    </select>
                  </ng-container>
                </div>
                <div class="s09-field" *ngIf="!f.briefTpl && f.multi">
                  <label>{{ f.label }}</label>
                  <div class="s09-chip-row">
                    <button type="button" class="s09-choice" *ngFor="let o of dayOptions(selectedMod, f, ms.values)"
                      [class.on]="hasMulti(ms.values, f.key, o)"
                      (click)="toggleModuleMulti(ms.id, f.key, o)">{{ o }}</button>
                  </div>
                </div>
                <div class="s09-field" *ngIf="f.allowCustom">
                  <label>{{ f.label }}</label>
                  <div class="s09-chip-row">
                    <button type="button" class="s09-choice" *ngFor="let o of choiceOptions(f)"
                      [class.on]="ms.values[f.key]===o"
                      (click)="patchModuleStepValue(ms.id, f.key, o)">{{ o }}</button>
                  </div>
                  <div class="s09-day-custom" *ngIf="!isPreviousDayDelay(ms.values[f.key])">
                    <input type="number" min="1" step="1" placeholder="Your own days"
                      [ngModel]="customDayCount(ms.values[f.key])"
                      (ngModelChange)="patchModuleStepValue(ms.id, f.key, formatCustomDays($event, customDayUnit(ms.values[f.key])))" />
                    <select [ngModel]="customDayUnit(ms.values[f.key])"
                      (ngModelChange)="patchModuleStepValue(ms.id, f.key, formatCustomDays(customDayCount(ms.values[f.key]) || 1, $event))">
                      <option value="business days">Business days</option>
                      <option value="days">Days</option>
                    </select>
                  </div>
                  <span class="s09-field-hint" *ngIf="f.key==='delay' && isPreviousDayDelay(ms.values[f.key])">This step waits the number of days the previous step recorded.</span>
                </div>
                <div class="s09-field" *ngIf="!f.briefTpl && !f.multi && isChoiceField(f) && !f.allowCustom">
                  <label>{{ f.label }}</label>
                  <span class="s09-field-hint" *ngIf="f.key==='stage' && stageHint">{{ stageHint }}</span>
                  <select [ngModel]="f.key==='from' ? waitFrom(ms.values) : ms.values[f.key]" (ngModelChange)="patchModuleStepValue(ms.id, f.key, $event)">
                    <option value="" disabled>Select…</option>
                    <option *ngFor="let o of choiceOptions(f)" [value]="o">{{ o }}</option>
                  </select>
                  <span class="s09-field-hint" *ngIf="f.key==='from'">Since the last step starts when the previous step finishes. From the start of the workflow counts from the day this workflow began.</span>
                </div>
                <div class="s09-field" *ngIf="!f.briefTpl && !f.multi && !isChoiceField(f) && fieldVisible(ms.kind, ms.values, f)">
                  <label>{{ f.label }}</label>
                  <input [ngModel]="ms.values[f.key]" (ngModelChange)="patchModuleStepValue(ms.id, f.key, $event)" />
                </div>
              </ng-container>
              <div class="s09-chip-row" *ngIf="isGated(ms.kind)">
                <span class="s09-gate-chip" *ngFor="let g of gateList(ms.kind)">{{ g }}</span>
              </div>
            </div>
            <button type="button" class="s09-btn-dashed" (click)="openModulePicker(i + 1)">+ Add step</button>
          </ng-container>
          <button type="button" class="s09-btn-dashed" *ngIf="!selectedMod.steps.length"
            (click)="openModulePicker(0)">+ Add step</button>
        </div>
        <button type="button" class="s09-btn danger-text" (click)="removeSelected()">Remove step</button>
      </div>

      <!-- Attempt detail -->
      <div class="s09-insp-body" *ngIf="inspMode==='attempt' && currentAttempt">
        <button type="button" class="s09-link" (click)="backToModule()">← Module settings</button>
        <div class="s09-field-grid">
          <div class="s09-field">
            <label>Day</label>
            <input [ngModel]="currentAttempt.day" (ngModelChange)="patchAttempt('day', $event)" />
          </div>
          <div class="s09-field">
            <label>Channel</label>
            <input [ngModel]="currentAttempt.channel" (ngModelChange)="patchAttempt('channel', $event)" />
          </div>
        </div>
        <span class="s09-field-hint">Day counts business days from the trigger; T means the stage threshold.</span>
        <div class="s09-chip-row">
          <button type="button" class="s09-choice" *ngFor="let ch of channels"
            [class.on]="currentAttempt.channel===ch" (click)="patchAttempt('channel', ch)">{{ ch }}</button>
        </div>
        <div class="s09-field">
          <label>Script / template</label>
          <select [ngModel]="currentAttempt.tpl" (ngModelChange)="patchAttempt('tpl', $event)">
            <option value="">Pick a script…</option>
            <option *ngFor="let t of templates" [value]="t.id">{{ t.name }}</option>
          </select>
        </div>
        <div class="s09-field">
          <label>What we ask of the office</label>
          <input [ngModel]="currentAttempt.ask" (ngModelChange)="patchAttempt('ask', $event)"
            placeholder="e.g. Tells patient to call hub / SP" />
        </div>
        <div class="s09-field">
          <label>Hub / SP codes at this point</label>
          <input class="s09-mono-input" [ngModel]="currentAttempt.hub" (ngModelChange)="patchAttempt('hub', $event)"
            placeholder="e.g. PH02.8 · PH03.2" />
          <span class="s09-field-hint">Context only: what the hub or SP is coding while this attempt runs.</span>
        </div>
        <div class="s09-tpl-preview" *ngIf="attemptPreview">
          <span class="s09-section-lbl">What the FRM gets</span>
          <div class="s09-tpl-card">
            <span class="s09-tpl-kind">{{ attemptPreview.kind || 'Template' }}</span>
            <strong>{{ attemptPreview.subject || attemptPreview.name }}</strong>
            <span class="s09-tpl-body">{{ attemptPreview.body }}</span>
          </div>
          <span class="s09-field-hint">Words in [brackets] are filled from the case.</span>
        </div>
        <button type="button" class="s09-btn danger-text" *ngIf="(selectedMod?.attempts?.length || 0) > 1"
          (click)="removeCurrentAttempt()">Remove this attempt</button>
      </div>

      <div class="s09-field s09-link-field" *ngIf="doc && (inspMode==='trigger' || selected)">
        <label>Connects to</label>
        <div class="s09-chip-row">
          <span class="s09-choice on" *ngFor="let id of outgoingOf(connectFrom())">
            {{ linkLabel(id) }}
            <button type="button" class="s09-wire-x" title="Remove connection"
              (click)="removeLink(connectFrom(), id)">×</button>
          </span>
          <span class="s09-field-hint" *ngIf="!outgoingOf(connectFrom()).length">No next step.</span>
        </div>
        <select [ngModel]="linkPick" (ngModelChange)="addLink(connectFrom(), $event)">
          <option value="">Add a connection…</option>
          <option *ngFor="let s of linkTargets(connectFrom())" [value]="s.id">{{ stepTitle(s) }}</option>
        </select>
        <span class="s09-field-hint">Or drag the bottom port on the canvas onto a step. Drag a line end off the canvas to detach it.</span>
      </div>

      <div class="s09-insp-f">
        <button type="button" class="s09-btn" (click)="closeInspector()">Done</button>
      </div>
    </aside>

    <!-- Validation drawer (hidden until toggled) -->
    <aside class="s09-panel s09-val" *ngIf="valOpen && !hasInspector">
      <div class="s09-val-h">
        <span>Validation</span>
        <div class="s09-val-h-right">
          <span class="s09-val-badge" [class.ok]="valBadge.ok" [class.bad]="!valBadge.ok">{{ valBadge.label }}</span>
          <button type="button" class="s09-icon-btn" (click)="closeValidation()" title="Hide validation">×</button>
        </div>
      </div>
      <div class="s09-val-body">
        <div class="s09-finding" *ngFor="let f of findings(); trackBy: trackFinding">
          <span class="s09-finding-lvl" [style.color]="f.colour">{{ f.level }}</span>
          <span class="s09-finding-where">{{ f.where }}</span>
          <span class="s09-finding-msg">{{ f.message }}</span>
        </div>
      </div>
      <div class="s09-val-f">
        <span class="s09-field-hint">Select a step or open Trigger to edit properties. Add steps from the library.</span>
        <button type="button" class="s09-btn s09-lib-toggle" style="width:100%" (click)="openLibrary()">Add step</button>
        <button type="button" class="s09-btn primary" style="width:100%" (click)="openTrigger()">Configure trigger</button>
      </div>
    </aside>

    <!-- Edge tab when validation is closed and inspector is not open -->
    <button *ngIf="!rightRailOpen" type="button" class="s09-rail-tab" (click)="openValidation()" title="Show validation">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <path d="M9 11l3 3L22 4"></path>
        <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
      </svg>
      <span class="s09-val-dot" [class.ok]="valBadge.ok" [class.bad]="!valBadge.ok"></span>
    </button>
  </div>
</div>
